;(function() {
  'use strict'

  angular.module('core.gMultiSwitch', [])
})()
